<template>
  <div>
    <!--    <div class="row justify-content-center">
          <div class="col-lg-5">-->

    <form
      @submit.prevent="continueStep"
      method="post"
      v-if="current_step_id === 0"
    >
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          required
          placeholder="Post title"
          v-model="form.title"
        />
      </div>

      <!--      <div class="form-group row">
        <item-type-component
          v-for="item in itemTypes"
          :key="item.value"
          :active="form.item_type === item.value"
          :title="item.title"
          v-on:clicked="() => changeType(item.value)"
        />
      </div>-->

      <div class="form-group">
        <textarea
          name="description"
          required
          cols="10"
          rows="5"
          class="form-control resize--none"
          placeholder="What's happening?"
          v-model="form.description"
        ></textarea>
      </div>

      <div class="form-group">
        <multiselect
          v-model="form.playlist"
          tag-placeholder="Add this as new playlist"
          placeholder="Select playlist"
          label="name"
          track-by="name"
          :options="playlists"
          :taggable="false"
          :searchable="true"
          :allow-empty="false"
        >
      </multiselect>
      </div>
      <div class="form-group row">
        <item-type-component
          v-for="item in versions"
          :key="item.value"
          :active="form.version === item.value"
          size="col-md-6"
          :title="item.title"
          v-on:clicked="() => changeVersion(item.value)"
        />
      </div>

      <div
        class="form-group"
        v-if="form.version === 1"
      >
        <multiselect
          v-model="form.plans"
          :options="plans"
          placeholder="Select plans"
          track-by="id"
          label="name"
          :custom-label="nameWithLang"
          :multiple="true"
        ></multiselect>
      </div>

      <div class="form-group">
        <multiselect
          v-model="form.tags"
          tag-placeholder="Add this as new tag"
          placeholder="Add tags"
          label="name"
          track-by="name"
          :options="options"
          :multiple="true"
          :taggable="true"
          @tag="addTag"
        ></multiselect>
      </div>

      <div class="form-group image-video">
        <div
          class="image-video__item"
          :class="{ active: upload_type === 'images' }"
          @click="imageOrVideo('images')"
        >
          <h3 class="image-video__item__title">Upload Images</h3>
          <img
            src="/images/svg/image_upload.svg"
            class="image-video__item__image upload_image"
            alt=""
            srcset=""
          />
        </div>
        <h1>OR</h1>
        <div
          class="image-video__item"
          :class="{ active: upload_type === 'video' }"
          @click="imageOrVideo('video')"
        >
          <h3 class="image-video__item__title">Upload Video</h3>
          <img
            src="/images/svg/video_upload.svg"
            class="image-video__item__image upload_video"
            alt=""
            srcset=""
          />
        </div>
      </div>

      <div class="form-group d-flex justify-content-end">
        <button
          type="submit"
          class="btn btn--primary h-45"
          style="letter-spacing: 3px"
        >
          Continue
        </button>
      </div>
    </form>
    <upload-images
      v-if="current_step_id === 1"
      :multiple="true"
      v-model="form.images"
    />

    <upload-video
      v-if="current_step_id === 2"
      v-model="form.video"
    />
    <div
      class="form-group"
      v-if="current_step_id === 2"
    >
      <upload-images
        v-if="form.version === 1"
        :multiple="false"
        label="Click or drag and drop to upload A Thumbnail (Optional)"
        v-model="form.thumbnail"
      />
    </div>
    <div
      class="mt-2 d-flex justify-content-between"
      v-if="current_step_id > 0"
    >
      <button
        class="btn btn-outline--primary"
        @click="() => (current_step_id = 0)"
      >
        Back
      </button>
      <button
        class="btn btn--primary"
        @click="submit"
        :disabled="loading"
      >
        {{ loading ? 'Submitting...' : 'Submit Post' }}
      </button>
    </div>
  </div>

  <!--    </div>
    </div>-->
</template>

<script>
import ItemTypeComponent from './components/ItemTypeComponent';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
import UploadImages from './components/upload-images';
import UploadVideo from './components/upload-video';

export default {
  name: 'create-item',
  components: { UploadVideo, UploadImages, ItemTypeComponent, Multiselect },
  props: ['plans', 'route', 'playlists'],
  data() {
    return {
      itemTypes: [
        { value: 1, title: 'Single Item' },
        { value: 2, title: 'Playlist Item' },
        {
          value: 3,
          title: 'Trailer Item',
        },
      ],
      versions: [
        { value: 0, title: 'Post is Free' },
        { value: 1, title: 'Post is Paid' },
      ],
      options: [],
      upload_type: 'images',
      steps: ['post', 'images', 'video'],

      current_step_id: 0,

      loading: false,
      form: {
        item_type: 1,
        version: 0,
        plans: [],
        tags: [],
        video: null,
        images: [],
        thumbnail: null,
        title: '',
        description: '',
        playlist: null,
      },
    };
  },
  created() {},
  methods: {
    changeType(type) {
      console.log('Changing type', type);
      this.form.item_type = type;
    },
    changeVersion(version) {
      console.log('Changing version', version);
      this.form.version = version;
      this.form.thumbnail = null;
    },
    nameWithLang({ name, pricing, duration }) {
      return `${name} — ${Number(pricing)} RWF for ${duration} days`;
    },
    addTag(newTag) {
      const tag = {
        name: newTag,
      };
      this.options.push(tag);
      this.form.tags.push(tag);
    },
    imageOrVideo(type) {
      this.upload_type = type;
    },
    continueStep() {
      if (this.form.tags.length === 0) {
        notify('error', 'Tags are required');
        return;
      }
      this.current_step_id = this.upload_type === 'images' ? 1 : 2;
    },
    async submit() {
      console.log('submit', this.form.playlist);
      console.log('Submitting');
      if (this.upload_type === 'images' && this.form.images.length === 0) {
        notify('error', 'Uploading images is required');
        return;
      }
      if (this.upload_type === 'video' && this.form.video == null) {
        console.log('Video is required');
        notify('error', 'Uploading video is required');
        return;
      }
      /*  if (this.form.version === 1 && this.form.thumbnail == null) {
        notify("error", "Thumbnail is required for paid posts");
        return;
      }*/
      try {
        this.loading = true;
        const formData = new FormData();
        formData.append('title', this.form.title);
        formData.append('description', this.form.description);
        for (let i = 0; i < this.form.tags.length; i++) {
          console.log(this.form.tags[i].name);
          formData.append('tags[]', this.form.tags[i].name);
        }

        for (let i = 0; i < this.form.plans.length; i++) {
          console.log(this.form.plans[i]);
          formData.append('plans[]', this.form.plans[i].id);
        }

        // formData.append("tags", this.form.tags.map(t => t.name));
        formData.append('version', this.form.version);
        formData.append('item_type', this.form.item_type);
        formData.append('flix_playlist_id', this.form.playlist.id);
        // formData.append("plans", JSON.stringify(this.form.plans.map(p => p.id)))
        if (this.upload_type === 'images') {
          for (let i = 0; i < this.form.images.length; i++) {
            console.log(this.form.images[i].image);
            formData.append('images[]', this.form.images[i].image);
          }
        } else {
          formData.append('video', this.form.video);
        }
        if (this.form.thumbnail)
          formData.append('thumbnail', this.form.thumbnail[0].image);

        const res = await axios.post(this.route, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        if (res.data.errors) {
          notify('error', res.data.errors);
        } else {
          notify('success', 'Post uploaded successfully!');

          this.reset();
          window.location = '';
        }
      } catch (e) {
        notify('error', 'Something went wrong');
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    reset() {
      this.form = {
        item_type: 1,
        version: 0,
        plans: [],
        tags: [],
        video: null,
        images: [],
        title: '',
        description: '',
        playlist: null,
      };
      this.current_step_id = 0;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.image-video {
  display: flex;
  margin: 20px 0;
  justify-content: space-between;
  align-items: center;

  h3 {
    font-size: 16px;
  }

  .upload_image {
    width: 100px;
  }

  .upload_video {
    width: 80px;
  }

  &__item {
    text-align: center;
    padding: 15px 15px;
    border-radius: 3px;
    border: solid #0f4c47 1px;
    height: 135px;
    width: 165px;
    cursor: pointer;
    transition: 0.2s;

    &.active {
      background-color: #e8faf9;
      border: solid #0f4c47 4px;
    }

    &__title {
      margin-bottom: 10px;
    }

    &__image {
      width: 100px;
    }
  }
}
</style>
